import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { togglePriceAlertHandler } from '../../../actions/baseActions';
import Helper from '../../modules/Helper';
import Checkbox from '../Common/Checkbox';

type PriceAlertCheckboxConfirmationProps = {
	priceAlertHandlerChecked: boolean;
	lng: string;
	togglePriceAlertHandler: (toggle: boolean) => void;
};

const PriceAlertCheckboxConfirmation: FC<PriceAlertCheckboxConfirmationProps> = (props) => {
	const { t } = useTranslation();
	const { lng, togglePriceAlertHandler, priceAlertHandlerChecked } = props;
	const isJapanese = lng === 'jp';
	const REGISTER_PRICE_ALERTS = Helper.bool(process.env.NEXT_PUBLIC_REGISTER_PRICE_ALERTS as string);

	if (!REGISTER_PRICE_ALERTS && !Helper.isPa() && !Helper.isSa()) {
		<></>;
	}
	return (
		<div>
			<Checkbox
				className={classNames({ japanese: isJapanese })}
				checked={priceAlertHandlerChecked}
				label={t('priceAlert.labelCar')}
				id="price-alert-checkbox-confirmation"
				onChange={() => togglePriceAlertHandler(!priceAlertHandlerChecked)}
			/>
		</div>
	);
};

export default connect(null, { togglePriceAlertHandler })(PriceAlertCheckboxConfirmation);
